export class WebhookV1StandardPayloadClassificationJobSkippedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationJobSkipped",
            "baseName": "classificationJobSkipped",
            "type": "WebhookV1ClassificationJobSkippedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobSkippedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
